<div class="weekday-card">
  <div class="weekday-header">
    <div>
      <span class="chart-eyebrow">Analytics</span>
      <h2 class="chart-title">Orçamentos por dia da semana</h2>
      <p class="chart-subtitle">Distribuição baseada no percentual já calculado</p>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="carregarDados()" [disabled]="isLoading">
      Atualizar
    </button>
  </div>

  <div *ngIf="isLoading" class="state-box">
    <div class="spinner-border text-primary" role="status"></div>
    <span>Carregando relatório...</span>
  </div>

  <div *ngIf="hasError && !isLoading" class="state-box error">
    <span>Não foi possível carregar o relatório por dia da semana.</span>
    <button class="btn btn-primary btn-sm" type="button" (click)="carregarDados()">Tentar novamente</button>
  </div>

  <div *ngIf="!isLoading && !hasError" class="weekday-table-shell">
    <div class="weekday-summary">
      <strong>Total de linhas:</strong> {{ dados.length }}
      <span>Rolagem interna com altura fixa</span>
    </div>

    <div class="weekday-scroll">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light sticky-head">
          <tr>
            <th scope="col">Dia da semana</th>
            <th scope="col" class="text-center">Qtd. Orçamentos</th>
            <th scope="col" class="text-end">Percentual</th>
            <th scope="col" class="text-end">Visual</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dados">
            <td>{{ item.diaSemana }}</td>
            <td class="text-center">{{ item.qtdOrcamentos }}</td>
            <td class="text-end fw-semibold">{{ item.percentual | number:'1.0-2' }}%</td>
            <td>
              <div class="bar-track">
                <div class="bar-fill" [style.width.%]="larguraBarra(item.percentual)"></div>
              </div>
            </td>
          </tr>
          <tr *ngIf="dados.length === 0">
            <td colspan="4" class="text-center text-muted py-4">Nenhum dado retornado pelo endpoint.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>